import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { Property } from '@codefluegel/wowis-rest-typescript-client';
import BookingsTable from '../../components/tables/BookingsTable';
import DashbboardContainer from '../../components/container/DashbboardContainer';
import useMedia from '../../hooks/useMedia';

interface Props {
  currentEstate: Property;
}

const DashBookings: FC<Props> = observer(props => {
  const { currentEstate } = props;
  const isMobile = useMedia('md');

  if (!currentEstate?.customerId) {
    return <div>Keine Kundennummer vorhanden</div>;
  }

  return (
    <DashbboardContainer
      label="Kontoauszug"
      btnLabel="Mehr"
      linkTo="/kontoauszug"
    >
      <Box
        width={1}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          width={1}
          paddingLeft={isMobile ? 1 : 4}
          paddingRight={isMobile ? 1 : 4}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <BookingsTable customerId={currentEstate?.customerId} preview />
        </Box>
      </Box>
    </DashbboardContainer>
  );
});

export default DashBookings;
